module.exports = __webpack_public_path__ + "static/media/ochaco-uraraka-lose.ee5f1bfe.png";